export const excerpt = (text: string, nbCarract = 250) => {
  if (!text) return null;
  if (text.length < nbCarract) return text;
  return text.substr(0, nbCarract) + '...';
};
